const state = {
  applicationSummary: undefined,
  latestLoanId: undefined,
  supportId: undefined,
  welcomeRewardsData: undefined,
  businessAddressPresentFlag: undefined,
  skippingGSTFlag: undefined,
};
export default state;
